import React, { useCallback, useContext, useState } from "react";
import FilterSecondPage_Coral from "./FilterSecondPage_Coral";
import TopkpisSecond_Coral from "./TopkpisSecond_Coral";
import TopkpisSecondMain_Coral from "./TopkpisSecondMain_Coral";
import RealWorldBox_Coral from "./SecondPageCharts_Coral/RealWorldBox_Coral";
import NetEnergydBox_Coral from "./SecondPageCharts_Coral/NetEnergydBox_Coral";
import RealWorldBar_Coral from "./SecondPageCharts_Coral/RealWorldBar_Coral";
import NetEnergyBar_Coral from "./SecondPageCharts_Coral/NetEnergyBar_Coral";
import ModeUtilization_Coral from "./SecondPageCharts_Coral/ModeUtilization_Coral";
import AvgDDBar_Coral from "./SecondPageCharts_Coral/AvgDDBar_Coral";
import Torquespeed_Coral from "./SecondPageCharts_Coral/Torquespeed_Coral";
import TorqueBox_Coral from "./SecondPageCharts_Coral/TorqueBox_Coral";
import Modal_Coral from "./SecondPageCharts_Coral/Modal_Coral";
import moment from "moment";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitialstates_coral";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PageSecond_Coral(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
  });

  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <FilterSecondPage_Coral
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecond_Coral
          gloablfilter={secondPageState}
          apiend="coral_drive_analysis/topkpis"
        />
        <TopkpisSecondMain_Coral
          gloablfilter={secondPageState}
          apiend="drivesecondpage/topkpismain"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-12 col-sm-6 col-lg-6">
              <div className="chartbox">
                <div className="row">
                  <RealWorldBox_Coral
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/realworldbox"
                  />
                  <div className="col-md-6">
                    <RealWorldBar_Coral
                      apiend="drivesecondpagecharts/realworldbar"
                      gloablfilter={secondPageState}
                    ></RealWorldBar_Coral>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0">
              <div className="chartbox">
                <div className="row">
                  <NetEnergydBox_Coral
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/netenergybox"
                  ></NetEnergydBox_Coral>
                  <div className="col-md-6">
                    <NetEnergyBar_Coral
                      apiend="drivesecondpagecharts/netenergybar"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Coral>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Row Ends here */}
          <div className="row mt-4 mb-3 equal-cols">
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0 ">
                <Torquespeed_Coral
                  apiend="drivesecondpagecharts/torquespeed"
                  gloablfilter={secondPageState}
                ></Torquespeed_Coral>
              </div>
            )}
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0">
                <TorqueBox_Coral
                  apiend="drivesecondpagecharts/torquebox"
                  gloablfilter={secondPageState}
                ></TorqueBox_Coral>
              </div>
            )}
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Soc Discharge/Cycle Analysis</div>
                <AvgDDBar_Coral
                  apiend="drivesecondpagecharts/avgddBar"
                  gloablfilter={secondPageState}
                ></AvgDDBar_Coral>
              </div>
            </div>
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Mode utilization</div>
                <ModeUtilization_Coral
                  gloablfilter={secondPageState}
                  apiend="drivesecondpagecharts/modeutilization"
                ></ModeUtilization_Coral>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecond_Coral;
